import React, { useEffect } from 'react'
import InputController from '../InputField/InputController';
import TelInput from '../TelInputField/TelInput';
import { phoneNumberRegex } from '../../../../lib/constants/regexConstant';

const PhoneAndEmailField = ({
  name,
  control,
  setValue,
  inputValue,
  isPhoneInputVisible,
  setIsPhoneInputVisible,
  ...props
}) => {
  // handle input change
  const handleInputChange = (e) => {
    let value = e.target.value;

    // Prevent misinterpretation when Ctrl+A is pressed
    const isCtrl = e.ctrlKey; // Check if Ctrl+A is triggered
    if (isCtrl) {
      return; // Do nothing; don't process input changes
    }

    setValue(name, value);
  };

  /* This function is called when a key is pressed. If the key pressed is not a valid phone number character 
     (i.e. alphabetic character or special character), switch to email input field.   */
  const handleKeyDown = (e) => {
    const charCode = e.key;
  
    // Exclude control keys like 'Ctrl+A', 'Ctrl+C', etc. from causing the input switch
    if (e.ctrlKey || e.metaKey) {
      return; // Do nothing if control key is pressed
    }   

    // invalid keys are the keys that are not allowed in a phone number
    const isInvalidKey = /^[a-zA-Z]$/.test(charCode) || /[!@#$%^&*(),.?":{}|<>]/.test(charCode);

    // If the key pressed is not allowed in a phone number, switch to email input
    if (isInvalidKey) {
      setIsPhoneInputVisible(false);
      
      // Only remove '91' prefix if it's a standalone number (not part of an email)
      // const isStandaloneNumber = phoneNumberRegex.test(inputValue);
      // const updatedValue = isStandaloneNumber && inputValue.startsWith("91") 
      //   ? inputValue.slice(2) 
      //   : inputValue;
        
      // setValue(name, updatedValue);
    }
  };

  useEffect(() => {
    setIsPhoneInputVisible(phoneNumberRegex.test(inputValue) || inputValue.startsWith('+'))
  }, [inputValue, setIsPhoneInputVisible])

  return (
    <>
      {!isPhoneInputVisible ? (
        <InputController
          label="Enter Email or Phone Number"
          name={name}
          autoFocus={true}
          control={control}
          value={inputValue}
          onChange={handleInputChange}
          onKeyDown={handleKeyDown}
          {...props}
        />
      ) : (
        <TelInput
          name={name}
          autoFocus={true}
          placeholder="Enter your phone number"
          control={control}
          value={inputValue}
          onChange={handleInputChange} // Handle phone input changes
          onKeyDown={handleKeyDown}
          {...props}
        />
      )}
    </>
  )
}

export default React.memo(PhoneAndEmailField)